import { type MouseEvent, type ReactNode } from "react";

import { Tooltip } from "@vega-core/components/Tooltip/Tooltip";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type ToolbarButtonProps = {
  icon: ReactNode;
  label: string;
  isActive?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
  className?: string;
};

export function ToolbarButton({
  icon,
  label,
  isActive = false,
  isDisabled = false,
  onClick,
  className,
}: ToolbarButtonProps) {
  const handleMouseDown = (e: MouseEvent) => {
    if (!onClick) return;

    e.preventDefault();

    if (!isDisabled) onClick();
  };

  return (
    <Tooltip content={label} providerProps={{ delayDuration: 300 }}>
      <button
        aria-label={label}
        className={cnTwMerge(
          "flex items-center justify-center size-7 rounded-md transition-colors",
          isActive
            ? "bg-background/component text-text/primary"
            : "text-text/secondary hover:bg-background/component/hover hover:text-text/primary",
          isDisabled && "opacity-30 pointer-events-none",
          className,
        )}
        disabled={isDisabled}
        onMouseDown={handleMouseDown}
        type="button"
      >
        {icon}
      </button>
    </Tooltip>
  );
}

export function ToolbarSeparator() {
  return <div className="mx-0.5 h-4 w-px bg-border/primary" />;
}
